@if (hero(); as hero) {
  <wl-hero-wrapper
    [hero]="hero"
    [id]="id()"
    [large]="hasCard()"
    [borderRadius]="!hasCard()"
    [hasBreadcrumbs]="hasBreadcrumbs()"
    [hasEssentRebranding]="hasEssentRebranding()"
  >
    <div
      class="hero"
      [class.hero--multi-column]="hasMultiColumnLayout()"
      [class.hero--has-card]="hasCard()"
      [class.hero--has-widget]="hasWidget()"
      [class.hero--rebranding]="hasEssentRebranding()"
    >
      <div class="hero__content">
        <div class="hero__content-primary">
          <wl-hero-card-wrapper [showCard]="hasCard()">
            <wl-hero-heading
              [hero]="hero"
              [hasEssentRebranding]="hasEssentRebranding()"
            />

            @if (showParagraph() && paragraph(); as paragraph) {
              <div class="hero__paragraph" *scText="paragraph"></div>
            }
            @if (showRichText() && richText(); as richText) {
              <wl-rich-text-wrapper [field]="richText">
                <div class="hero__rich-text"></div>
              </wl-rich-text-wrapper>
            }

            @if (showButtonGroup()) {
              <wl-hero-button-group
                class="hero__button-group"
                [hero]="hero"
                [inverted]="isEssent()"
                [large]="hasCard()"
              />
            }
          </wl-hero-card-wrapper>
        </div>
        @if (showBottomImage() && bottomImage(); as bottomImage) {
          <div class="hero__content-secondary" [ngClass]="bottomImageClass()">
            <img class="hero__bottom-image" *scImage="bottomImage" />
          </div>
        }
        @if (
          showBottomImageMobile() && bottomImageMobile();
          as bottomImageMobile
        ) {
          <div class="hero__content-secondary d-md-none">
            <img class="hero__bottom-image" *scImage="bottomImageMobile" />
          </div>
        }
      </div>
      @if (hasMultiColumnLayout()) {
        <div class="hero__sidebar">
          @if (hasWidget()) {
            <wl-hero-widget
              [hero]="hero"
              [hasEssentRebranding]="hasEssentRebranding()"
            />
          } @else {
            @if (showMainImage() && mainImage(); as mainImage) {
              <div class="hero__main-image-wrapper">
                <div class="hero__main-image-container">
                  <img class="hero__main-image" *scImage="mainImage" />
                </div>
              </div>
            }
          }
        </div>
      }
    </div>
  </wl-hero-wrapper>
}
